/**
 * Intentional no-op function to return from useEffects.
 */
// eslint-disable-next-line @typescript-eslint/no-empty-function
const fnNoOp = () => {
  /* This is intended as a no-op function used to return from useEffects */
};

/**
 * A functional React component that renders nothing (no operation).
 *
 * @returns {JSX.Element} An empty React fragment.
 */
export const FnNoEl = () => <></>;

export default fnNoOp;
